import * as React from 'react';

import type { VariantProps } from 'tailwind-variants';
import { tv } from 'tailwind-variants';

import type { IconProps } from '@avodah-inc/types';
import { cn } from '@avodah-inc/ui/utils';

const cameraVariants = tv({
  base: 'text-base-black',
  variants: {
    variant: {
      default: 'text-base-black',
      onDark: 'text-base-white',
      primary: 'text-primary',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});

export type CameraProps = React.SVGAttributes<SVGSVGElement> &
  VariantProps<typeof cameraVariants> &
  IconProps;

export const Camera = React.forwardRef<SVGSVGElement, CameraProps>(
  (
    {
      className,
      variant,
      viewBox = '0 0 20 21',
      width,
      height,
      fill = 'currentColor',
      ...props
    },
    ref,
  ) => {
    return (
      <svg
        width={width}
        height={height}
        viewBox={viewBox}
        fill={fill}
        className={cn(
          cameraVariants({
            variant,
            className,
          }),
        )}
        ref={ref}
        {...props}
      >
        <path d="M6.78398 3.326C6.90888 3.07768 7.10031 2.86896 7.33692 2.7231C7.57354 2.57725 7.84603 2.50001 8.12398 2.5H11.888C12.1667 2.50001 12.4399 2.57767 12.6769 2.72428C12.914 2.87088 13.1055 3.08063 13.23 3.33L13.815 4.5H15.505C16.168 4.5 16.8039 4.76339 17.2727 5.23223C17.7416 5.70107 18.005 6.33696 18.005 7V10.761C17.4362 10.289 16.7778 9.93694 16.0694 9.72607C15.361 9.5152 14.6173 9.44986 13.883 9.534C13.645 8.58821 13.0698 7.76188 12.2655 7.21025C11.4613 6.65863 10.4832 6.41968 9.51519 6.53831C8.54716 6.65693 7.65576 7.12496 7.00848 7.85447C6.36119 8.58397 6.00256 9.52473 5.99998 10.5C6.00002 11.3929 6.29869 12.2602 6.84847 12.9638C7.39825 13.6675 8.16755 14.167 9.03398 14.383C8.91148 15.4551 9.10839 16.5394 9.59998 17.5H4.50598C3.84294 17.5 3.20706 17.2366 2.73821 16.7678C2.26937 16.2989 2.00598 15.663 2.00598 15V7C2.00598 6.33696 2.26937 5.70107 2.73821 5.23223C3.20706 4.76339 3.84294 4.5 4.50598 4.5H6.19598L6.78398 3.326ZM9.99998 7.5C11.393 7.5 12.564 8.45 12.902 9.736C12.0371 9.99953 11.2504 10.4718 10.6111 11.1111C9.97175 11.7504 9.49952 12.5371 9.23598 13.402C8.5318 13.2155 7.91948 12.7793 7.51323 12.1746C7.10698 11.57 6.93453 10.8382 7.02805 10.1157C7.12156 9.39331 7.47466 8.72956 8.02148 8.24827C8.56831 7.76698 9.27152 7.50103 9.99998 7.5ZM19 15C19 16.1935 18.5259 17.3381 17.682 18.182C16.838 19.0259 15.6935 19.5 14.5 19.5C13.3065 19.5 12.1619 19.0259 11.318 18.182C10.4741 17.3381 9.99998 16.1935 9.99998 15C9.99998 13.8065 10.4741 12.6619 11.318 11.818C12.1619 10.9741 13.3065 10.5 14.5 10.5C15.6935 10.5 16.838 10.9741 17.682 11.818C18.5259 12.6619 19 13.8065 19 15ZM15 13C15 12.8674 14.9473 12.7402 14.8535 12.6464C14.7598 12.5527 14.6326 12.5 14.5 12.5C14.3674 12.5 14.2402 12.5527 14.1464 12.6464C14.0527 12.7402 14 12.8674 14 13V14.5H12.5C12.3674 14.5 12.2402 14.5527 12.1464 14.6464C12.0527 14.7402 12 14.8674 12 15C12 15.1326 12.0527 15.2598 12.1464 15.3536C12.2402 15.4473 12.3674 15.5 12.5 15.5H14V17C14 17.1326 14.0527 17.2598 14.1464 17.3536C14.2402 17.4473 14.3674 17.5 14.5 17.5C14.6326 17.5 14.7598 17.4473 14.8535 17.3536C14.9473 17.2598 15 17.1326 15 17V15.5H16.5C16.6326 15.5 16.7598 15.4473 16.8535 15.3536C16.9473 15.2598 17 15.1326 17 15C17 14.8674 16.9473 14.7402 16.8535 14.6464C16.7598 14.5527 16.6326 14.5 16.5 14.5H15V13Z" />
      </svg>
    );
  },
);

Camera.displayName = 'Camera';
